import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/components/builtin/global-error.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/components/client-page.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/components/client-segment.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/components/http-access-fallback/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/components/layout-router.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/components/render-from-template-context.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/lib/framework/boundary-components.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/lib/metadata/generate/icon-mark.js");
